import React, { useRef, useState } from "react";
import { Whisper, Popover } from "rsuite";
import { MdOutlineEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Offcanvas } from "react-bootstrap";
import AddBatchForm from "../pharmacy/AddBatchForm"; // make sure path is correct

const ActionCellPharmacy = ({ batchItem,onDelete }) => {
  const triggerRef = useRef(null);
  
  // ---- Offcanvas state ----
  const [showAddPharmacy, setShowAddPharmacy] = useState(false);
  const [editingBatch, setEditingBatch] = useState(null);
   
  const handleDeleteBatch = () => {
  if (window.confirm("Are you sure you want to delete this batch?")) {
    onDelete(batchItem.id); // or another unique identifier
    if (triggerRef.current) triggerRef.current.close(); // close popover
  }
};
  const handleClose = () => {
    setShowAddPharmacy(false);
    setEditingBatch(null); // clear after closing
  };

  // ---- Edit button handler ----
  const handleEditBatch = (batchData) => {
    setEditingBatch(batchData); // populate form with batch info
    setShowAddPharmacy(true);
    if (triggerRef.current) triggerRef.current.close(); // close popover
  };

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-44">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">
        Actions
      </div>

      {/* ---- Edit Medicine ---- */}
      <div
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
        onClick={() => handleEditBatch(batchItem)}
      >
        <MdOutlineEdit className="text-lg text-gray-500" />
        <span>Edit</span>
      </div>

      {/* ---- Delete ---- */}
     <div
  className="flex items-center gap-2 px-3 py-2 text-sm text-red-600 cursor-pointer hover:bg-red-50 rounded-md"
  onClick={handleDeleteBatch}
>
  <RiDeleteBin6Line className="text-lg text-red-500" />
  <span>Delete</span>
</div>

    </Popover>
  );

  return (
    <>
      {/* ---- Whisper (3-dots menu) ---- */}
      <Whisper
        ref={triggerRef}
        placement="topEnd"
        trigger="click"
        speaker={renderPopover}
      >
        <button
          className="inline-flex items-center justify-center gap-2 w-10 h-10 rounded-md hover:bg-gray-100"
          title="More actions"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="lucide lucide-ellipsis h-4 w-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="1"></circle>
            <circle cx="19" cy="12" r="1"></circle>
            <circle cx="5" cy="12" r="1"></circle>
          </svg>
        </button>
      </Whisper>

      {/* ---- AddBatchForm Offcanvas ---- */}
      <Offcanvas
        show={showAddPharmacy}
        onHide={handleClose}
        placement="end"
        backdrop="static"
        style={{ width: "50%" }}
      >
        <Offcanvas.Header
          closeButton
          style={{ borderBottom: "1px solid #eee", padding: "10px 20px" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {/* Left: Title + Subtitle */}
            <div>
              <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>
                {editingBatch ? "Edit Batch" : "Edit Batch"}
              </h3>
              <span style={{ fontSize: "13px", color: "#888" }}>
                Add or Edit Stock Batches
              </span>
            </div>

            {/* Right: Save Button */}
            <button
              type="submit"
              className="gradient-button"
              style={{ fontSize: "12px", padding: "6px 12px" }}
            >
             UPDATE
            </button>
          </div>
        </Offcanvas.Header>

        <Offcanvas.Body style={{ padding: "10px 20px" }}>
          <AddBatchForm editingBatch={editingBatch} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ActionCellPharmacy;
